import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iad-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Error404Component {
}
